import { render, staticRenderFns } from "./AvatarProp.vue?vue&type=template&id=dedb5f52&"
import script from "./AvatarProp.vue?vue&type=script&lang=js&"
export * from "./AvatarProp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports